import { MapPinIcon } from '@heroicons/react/20/solid'

import { dateToString } from 'utils/date'

// const getAB = (result, abandonment) => {
//   return abandonment ? `${result} (AB)` : result
// }

const Timetable = ({ matches, vsIdx = 1 }) =>
  matches?.map((match, idx) => {
    const isWO =
      match.obs?.includes('WO') ||
      match.obs?.includes('W.O') ||
      (match?.wo &&
        match.result
          .replaceAll('-', '')
          .replaceAll(' ', '')
          .replaceAll('/', '') === '000000')
    const isJWO = match?.jwo
    let result = isJWO
      ? 'WO Justificat'
      : isWO || match?.wo
      ? 'WO'
      : match.result
      ? match.result
      : 'VS'

    if (match.injury && !isJWO && !isWO) {
      result = result.includes('0-0')
        ? result.replace('0-0', 'Lesió')
        : `${result} / Lesió`
    }

    if (match.teams.find(({ name }) => name.toLowerCase().includes('bye'))) {
      result = '-'
    }
    return (
      <div key={idx}>
        {/* MOBILE */}
        <div className="grid grid-cols-1 lg:hidden mb-6">
          {idx > 0 && (
            <div className="border-t border-1 border-blue border-opacity-40 mb-5"></div>
          )}
          <div className="flex bg-sec-blue py-4 rounded-t-md pl-6">
            {match.date && (
              <img
                className="h-5 w-5 object-cover mr-2"
                src="/assets/icon-clock.svg"
                alt=""
              />
            )}
            <p
              className={`truncate font-alliance-medium text-blue ${
                match.noDate ? 'font-bold' : ''
              }`}
            >
              {match.date || match.noDate}
            </p>
            {match.playPlace && (
              <MapPinIcon className="h-5 w-5 mr-2 ml-6" aria-hidden="true" />
            )}
            <p className="truncate text-sm text-blue">{match.playPlace}</p>
          </div>
          <div className="grid grid-cols-2 bg-sec-grey-4">
            {match.teams.map((player, idxPlayer) => (
              <>
                <div
                  key={player.name}
                  className={`relative flex items-center space-x-3 px-6 py-5 flex-1  ${
                    ((match?.winner === 1 || match?.won === 'Local') &&
                      (idxPlayer === 2 || idxPlayer === 3)) ||
                    ((match?.winner === 2 || match?.won === 'Visiting') &&
                      (idxPlayer === 0 || idxPlayer === 1))
                      ? 'opacity-50'
                      : ''
                  }`}
                >
                  <div className="flex-shrink-0">
                    <img
                      className="h-12 w-12 rounded-full object-cover object-top shadow-md"
                      src={
                        player.imageUrl || '/assets/images/players/no-photo.svg'
                      }
                      alt=""
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <a href="#" className="focus:outline-none">
                      <span className="absolute inset-0" aria-hidden="true" />
                      <p className="text-[16px] font-bold text-blue">
                        {player.name}
                      </p>
                      <p className="text-[14px] text-blue">{player.score}</p>
                    </a>
                  </div>
                </div>
                {idxPlayer === vsIdx && (
                  <div className="flex justify-center items-center flex-1 col-span-2 bg-sec-grey-3 py-2">
                    <p className="text-[18px] font-bold text-blue">{result}</p>
                  </div>
                )}
              </>
            ))}
          </div>
        </div>

        {/* LG */}
        <div className="hidden lg:flex">
          <div
            className={`flex-1 mx-2 border-blue border-opacity-40 pb-7 ${
              idx !== 0 ? 'border-t' : ''
            }`}
          >
            <div className="flex mt-8">
              {match.date && (
                <img
                  className="h-5 w-5 object-cover mr-2"
                  src="/assets/icon-clock.svg"
                  alt=""
                />
              )}
              <p
                className={`truncate text-sm text-blue ${
                  match.noDate ? 'font-bold' : ''
                }`}
              >
                {match.date || match.noDate}
              </p>
              {match.playPlace && (
                <MapPinIcon className="h-5 w-5 mr-2 ml-6" aria-hidden="true" />
              )}
              <p className="truncate text-sm text-blue">{match.playPlace}</p>
            </div>
            <div className="mt-5">
              <div className="flex my-2 bg-sec-grey-4">
                {match.teams.map((player, idxPlayer) => (
                  <>
                    <div
                      key={player.name}
                      className={`relative flex items-center space-x-3 px-6 py-5 flex-1 ${
                        ((match?.winner === 1 || match?.won === 'Local') &&
                          (idxPlayer === 2 || idxPlayer === 3)) ||
                        ((match?.winner === 2 || match?.won === 'Visiting') &&
                          (idxPlayer === 0 || idxPlayer === 1))
                          ? 'opacity-50'
                          : ''
                      }`}
                    >
                      <div className="flex-shrink-0">
                        <img
                          className="h-12 w-12 rounded-full object-cover object-top shadow-md"
                          src={
                            player.imageUrl ||
                            '/assets/images/players/no-photo.svg'
                          }
                          alt=""
                        />
                      </div>
                      <div className="min-w-0 flex-1">
                        <div className="focus:outline-none">
                          <span
                            className="absolute inset-0"
                            aria-hidden="true"
                          />
                          <p className="text-sm font-bold text-blue">
                            {player.name}
                          </p>
                          <p className="truncate text-sm text-blue">
                            {player.score}
                          </p>
                        </div>
                      </div>
                    </div>
                    {idxPlayer === vsIdx && (
                      <div
                        className={`flex justify-center items-center flex-${
                          match.abandonment ? '2' : '1'
                        }`}
                      >
                        <p className="text-2xl font-bold text-blue">{result}</p>
                      </div>
                    )}
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  })

export default Timetable
